<template>
  <v-list two-line subheader>
    <v-subheader>General</v-subheader>
    <v-list-tile @click>
      <v-list-tile-action>
        <v-switch v-model="model.ec"></v-switch>
      </v-list-tile-action>
      <v-list-tile-content @click="model.ec = !model.ec">
        <v-list-tile-title>Echo canceler</v-list-tile-title>
        <v-list-tile-sub-title>Enable or disable echo canceler</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click="changeFilterLength">
      <v-list-tile-action>
        <v-btn icon>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Filter length {{model.filter_length_ms}} ms</v-list-tile-title>
        <v-list-tile-sub-title>Echo canceler filter length (ms)</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click>
      <v-list-tile-action>
        <v-switch v-model="model.el"></v-switch>
      </v-list-tile-action>
      <v-list-tile-content @click="model.el = !model.el">
        <v-list-tile-title>Echo limiter</v-list-tile-title>
        <v-list-tile-sub-title>Enable or disable echo limiter</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click>
      <v-list-tile-action>
        <v-switch v-model="model.auto_threshold"></v-switch>
      </v-list-tile-action>
      <v-list-tile-content @click="model.auto_threshold = !model.auto_threshold">
        <v-list-tile-title>Auto threshold</v-list-tile-title>
        <v-list-tile-sub-title>Enable or disable auto thresold for echo limiter</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile :disabled="model.auto_threshold" @click="changeThreshold">
      <v-list-tile-action>
        <v-btn icon>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Threshold {{model.threshold.toFixed(4)}}</v-list-tile-title>
        <v-list-tile-sub-title>Echo limiter intervention threshold</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile @click="changeRatioThreshold">
      <v-list-tile-action>
        <v-btn icon>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Mic Spk Ratio Threshold {{model.ratio_threshold.toFixed(0)}}</v-list-tile-title>
        <v-list-tile-sub-title>When microphone capture louder then speaker, disable the echo limiter</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-subheader>Graph</v-subheader>
    <v-list-tile @click>
      <v-list-tile-action>
        <v-btn icon>
          <v-icon>add</v-icon>
        </v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Add Track</v-list-tile-title>
        <v-list-tile-sub-title>Add track to graph</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-group v-for="(track, t) in model.tracks" :key="t" v-model="track.active">
      <template v-slot:activator>
        <v-list-tile>
          <v-list-tile-action>
            <v-btn icon @click.native="doNothing">
              <v-icon>track</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Track #{{t+1}}</v-list-tile-title>
            <v-list-tile-sub-title></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <v-list-tile>
        <v-list-tile-action>
          <v-btn icon>
            <v-icon>add</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Add Function</v-list-tile-title>
          <v-list-tile-sub-title>Add Function to track #{{t+1}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-for="(fun, f) in track.y" :key="f" @click="changeFunction(t, f)">
        <v-list-tile-action>
          <v-btn icon>
            <v-icon>timeline</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Function #{{f+1}}: {{fun.id}}</v-list-tile-title>
          <v-list-tile-sub-title></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
    <v-list-tile>
      <v-list-tile-action>
        <v-btn @click="save">Save</v-btn>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>
<script>
const SCHEMA = {
  type: "object",
  title: "Audio settings",
  properties: {
    el: {
      type: "string"
    },
    ec: {
      type: "string"
    }
  }
};
import { mapState } from "vuex";
import Vue from "vue";

export default {
  mounted() {
    this.$store.dispatch("audio/fetch").then(settings => {
      console.log(settings);
      Vue.set(this, "model", settings);
    });
  },
  data: () => ({
    schema: SCHEMA,
    model: {
      ec: false,
      el: true,
      auto_threshold: false,
      filter_length_ms: 100,
      threshold: 0.005,
      ratio_threshold: 40,
      tracks: [
        {
          y: [{ id: "mic" }]
        },
        {
          y: [{ id: "spk" }, { id: "threshold" }]
        }
      ]
    }
  }),
  computed: {
    ...mapState("audio", ["settings"])
  },
  methods: {
    save() {
        let settings = this.model;
        this.settings.tracks.forEach(track => {
            delete track.active;
            
        });
        console.log (JSON.stringify(settings));
        this.$store.dispatch('audio/saveSettings', settings);
    },
    doNothing() {},
    changeFunction(t, f) {
      let target = "mic";
      switch (this.model.tracks[t].y[f].id) {
        case "mic":
          target = "out";
          break;
        case "out":
          target = "spk";
          break;
        case "spk":
          target = "ratio";
          break;
        case "ratio":
          target = "threshold";
          break;
        case "threshold":
          target = "ratio_threshold";
          break;
        case "ratio_threshold":
          target = "none";
          break;
        case "none":
          target = "mic";
          break;
      }
      this.model.tracks[t].y[f].id = target;
    },
    changeRatioThreshold() {
      let value = this.model.ratio_threshold;
      if (value < 10) {
        value += 1;
      } else if (value < 100) {
        value += 10;
      } else {
        value = 1;
      }
      this.model.ratio_threshold = value;
    },
    changeThreshold() {
      let value = this.model.threshold;
      /*
      console.log(value);
      value = value.toFixed(4);
      console.log(value);
      */
      if (value < 0.001) {
        value += 0.0001;
      } else if (value < 0.01) {
        value += 0.001;
      } else if (value < 0.1) {
        value += 0.01;
      } else {
        value = 0.0001;
      }
      this.model.threshold = value;
    },
    changeFilterLength() {
      if (this.model.filter_length_ms < 100) {
        this.model.filter_length_ms += 10;
      } else if (this.model.filter_length_ms < 1000) {
        this.model.filter_length_ms += 100;
      } else {
        this.model.filter_length_ms = 10;
      }
    }
  }
};
</script>